import React, { useState } from 'react';
import styles, { mainCls } from './styles';
import createStyle from 'shared-utils/src/createStyle';
import { Icon } from 'shared-vectors';
import SendToPhone from 'shared-vectors/icons/SendToPhone';
import HeaderTooltipQRCode from '../QRCodeTooltipFactory/HeaderTooltipQRCode';
import calculateSizeBasedOnUrlLength from 'shared-utils/src/calculateSizeBasedOnUrlLength';
import FakeQRCode from '../QRCodeFallbacks/FakeQRCode';

const useStyles = createStyle(styles);

const QRCodeFallbackContainer = ({
  isVisibleTooltip = true,
  url = '',

}) => {
  const size = calculateSizeBasedOnUrlLength(url);
  const cls = useStyles({ size });

  return (
    <div className={mainCls}>
      <button type="button" onClick={() => {}} className={`${[mainCls]}__btnqr-fixed`} >
        <Icon
          color="f1"
          width={24}
          name={SendToPhone}
          fill
        />
      </button>
      <HeaderTooltipQRCode 
        content={
          <FakeQRCode size={size}/>
        } 
        visible={isVisibleTooltip} hideTooltip={() =>{}}
      />
    </div>
  );
};

export default QRCodeFallbackContainer;
